import {Injectable} from '@angular/core';
import {BaseService} from "../../../services/base.service";
import {HttpClient, HttpHeaders} from "@angular/common/http";
import {User} from "../models/user";
import {AuthService} from "../../../services/auth.service";

@Injectable({
    providedIn: 'root'
})
export class MobileConfigService extends BaseService {

    constructor(private httpClient: HttpClient, private authService: AuthService) {
        super();
    }



    public getMobileConfig() {

        let serviceURL = this.baseAPI + "adham/configs/mobile"
        return this.httpClient.get<any>(serviceURL, this.authService.getHttpOptions());

    }




}
